import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuConf } from 'src/app/beans/menu/menu-conf/menu-conf.bean';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { MainMenuComponent } from 'src/app/components/main-menu/main-menu.component';
import { MatDrawer } from '@angular/material/sidenav';
import { MainHeaderComponent } from 'src/app/components/main-header/main-header.component';
import { User } from 'src/app/beans/login/user/user.bean';

@Component({
  selector: 'main',
  templateUrl: './main.page.html',
  styleUrls: ['./main.page.scss']
})
export class MainPage implements OnInit {

  private drawer: MatDrawer
  @ViewChild('drawer'   ) set _drawer       (drawer     : MatDrawer           ){
    this.drawer = drawer
  }

  private mainMenu: MainMenuComponent
  @ViewChild('mainMenu' ) set _mainMenu     (mainMenu   : MainMenuComponent   ){
    this.mainMenu = mainMenu
    if (mainMenu) this.initMenuPage()
  }

  private mainHeader: MainHeaderComponent
  @ViewChild('mainHeader' ) set _mainHeader (mainHeader : MainHeaderComponent ){
    this.mainHeader = mainHeader
    if (mainHeader) this.initMenuStatus()
    
  }

  menuConf  : MenuConf

  backdrop  : boolean = true
  drawerMode: string  = "over"

  // @HostListener('window:resize', ['$event'])
  // onResize(event: any ) {
  //   this.checkSize()
  // }

  //checkSize(){
    //if(window.innerWidth <= 850){
      // this.backdrop   = true
      // this.drawerMode = "over"
      // }else{
    //   this.backdrop   = false
    //   this.drawerMode = "side"
    // }
  //}

  constructor(
    private _session: SessionManager
  ) { }

  async ngOnInit() {
    
  }

  async ngAfterViewInit() {
    await this.restoreMenu()
    //this.checkSize()
  }

  async restoreMenu () {
    const menuConf = this._session.menu().get()
  
    if (!MenuConf.isKind ( menuConf ) ) { 

      const user  = this._session.user().get()   
      const item = MenuConf.getMenuItem ( user as User , this.mainMenu.items )
       this.menuConf = {
         opened: false,
         item  : item
       }
     }else{
       this.menuConf = menuConf as MenuConf       
     }    
      
     this._session.menu().set(this.menuConf)

     if (this.mainHeader) this.initMenuStatus()
     if (this.mainMenu  ) this.initMenuPage()

  }

  initMenuStatus () {
    if (this.menuConf && this.menuConf.opened){
      setTimeout( ()=>{
        this.mainHeader.drawer.open()
      }, 0) 
    }
  }

  initMenuPage () {
    if (this.menuConf && this.menuConf.item){
      setTimeout( ()=>{    
        const id = this.menuConf.item.id 
        this.mainMenu.selectElement( id ) 
      }, 0) 
    }
  }
}
